module.exports = __webpack_public_path__ + "img/clipboard.533add90.png";